module.exports = __webpack_public_path__ + "static/media/weatherForecast.c628e5b8.png";